import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { IHTMLDiv, IHTMLInput } from "../interfaces/InputsInterfacesType1";
import { IInputValidationItemController } from "../../../../factorys/inputvalidation/interfaces/InputValidationInterfaces";


/**
 * works for;
 * TextInput, SelectInput
 */
interface IProps<T> {
  value: T | undefined;
  disabled?: boolean | undefined;
  classNameInput?: string;
  classNameFrame?: string;
  disabledClass: string
}
export interface IRadiosControllerType1Return<T> extends IInputValidationItemController {
  blur: boolean; setBlur: Dispatch<SetStateAction<boolean>>;
  refInput: IHTMLInput | null, setRefInput: (it: IHTMLInput | null) => void,
  setRefFrame: (it: IHTMLDiv | null) => void
  value: T | undefined, setValue: Dispatch<T>
}
export const IRadiosControllerType1 = <T>(props: IProps<T>): IRadiosControllerType1Return<T> => {
  
  const tag = " IRadiosControllerType1";
  //console.log(tag + " START");

  const [value, setValue] = useState<T | undefined>(props.value);
  // useEffect(() => {
  //   //console.log("value: " +value)
  // }, [value]);
  const [blur, setBlur] = useState<boolean>(false);

  //refs
  let refDiv: IHTMLDiv | null = null;
  function setRefDiv(it: IHTMLDiv | null) {
    try {
      if (it == null) return;
      refDiv = it;
      setDisabled(props.disabled);
    } catch (e) {}
  }

  let refInput: IHTMLInput | null = null;
  function setRefInput(it: IHTMLInput | null) {
    try {
      if (it == null) return;
      refInput = it;
      setDisabled(props.disabled);
    } catch (e) {}
  }
  //states


  //init
  useEffect(() => {
    //console.log(tag + " => onMount");
    setDisabled(props.disabled);
    //setDisabled(true)
    return () => {
      //console.log(tag + " => onUnmount");
    };
  }, []);


  useEffect(() => {
    try {
      setDisabled(props.disabled);
    } catch (e) {}
  }, [props.disabled]);


  function setDisabled(disabled: boolean = true) {
    if(refDiv != null) {
      try {
        refDiv.className = disabled ? (props.classNameFrame + " " + props.disabledClass) : props.classNameFrame!!;
        //refDiv.className = disabled ? (props.classNameFrame + " ") : props.classNameFrame!!;
      } catch (e) {
        refDiv!!.className = disabled ? (props.disabledClass) : "";
      }
    }

    if(refInput != null) {
      try {
          refInput.disabled = disabled;
          refInput.className = disabled ? (props.classNameInput!! + " " + props.disabledClass) : props.classNameInput!!;
        } catch (e) {
          refDiv!!.className = disabled ? (props.disabledClass) : "";
        } 
    }
  }
  return { 
    blur, setBlur,
    refInput, setRefInput, 
    setRefFrame: setRefDiv, 
    value, setValue
  };
}